type Context = 'company';

type Section =
  | 'profile'
  | 'slugs'
  | 'similar'
  | 'nextgen'
  | 'news'
  | 'dnc-check'
  | 'core'
  | 'jobs'
  | 'job-details'
  | 'exchange'
  | 'agent-intel'
  | 'intel-summary'
  | 'intel-simple'
  | 'search-intent'
  | 'tech-intelligence-summary'
  | 'tech-intelligence-products';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  profile: 'company-profile',
  slugs: 'company-slugs',
  nextgen: 'company-nextgen',
  similar: 'company-similar',
  news: 'company-news',
  core: 'company-core',
  'dnc-check': 'company-dnc-check',
  jobs: 'company-jobs',
  'job-details': 'company-job-details',
  exchange: 'company-exchange',
  'agent-intel': 'company-agent-intel',
  'intel-summary': 'company-intel-summary',
  'intel-simple': 'company-intel-simple',
  'search-intent': 'company-search-intent',
  'tech-intelligence-summary': 'company-tech-intelligence-summary',
  'tech-intelligence-products': 'company-tech-intelligence-products',
};
